import { DesignTool, EditAction } from '../../../../design-tool';

export const addAndCommitAction = (tool: DesignTool, action: EditAction) => {
  tool.inputHandler.setCursor('progress');
  tool.undoActions.splice(0, tool.undoActions.length);
  tool.actions.push(action);
  tool.intersection = undefined;
  action.commit();
  tool.onEdited?.();
  tool.inputHandler.setCursor('crosshair');
};
